<template>
    <div v-if="booking" class="break-after delivery-note">
        <!-- <h1>DeliveryNote</h1> -->
        <!-- <hr> -->
        <b-row>
            <b-col cols="8">
                <img src="@/assets/img/brand/Sodexo_Logotype_Blue.png" alt="Sodexo Logo" class="img-fluid"
                    style="width: 250px;" />
            </b-col>
            <b-col style="text-align: right;">
                <img src="@/assets/img/brand/logivialogga_transp_min.png" alt="Transplanet Logo" class="img-fluid" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br /><br />
                <!-- <hr> -->
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="8">
                <h1>Följesedel {{ b.TspDocNo }}</h1><br>
                <b-row>
                <b-col>
                    Datum:<br/>
                    <h1>{{ b.DeliveryDateText }}</h1>
                </b-col>
                <b-col>
                    Rutt:<br/>
                    <h1>{{ b.TourName }}</h1>
                </b-col>
                </b-row>                
            </b-col>
            <b-col style="text-align: right;" cols="4">
                <!-- <span class="libre-barcode-128-regular" style="font-size:55px">{{b.TspDocNo}}</span> -->
                <svg :ref="getBcRef(b.TspDocNo)" :id="getBcRef(b.TspDocNo)"></svg>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="8">
                <b-card style="height: 220px; font-weight: bolder;">
                    <h1>
                        {{ b.DeliveryPlaceName }}<br>
                        {{ b.DeliveryPlaceStreet }}<br>
                        {{ b.DeliveryPlacePostCode }}&nbsp;{{ b.DeliveryPlaceCity }}
                    </h1>
                </b-card>
            </b-col>
            <b-col>
                <b-card style="height: 220px;">
                    <b-row>
                        <b-col>
                            <b>Telefon:</b>
                        </b-col>
                        <b-col>
                            {{ b.DeliveryPhone }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b>Portkod:</b>
                        </b-col>
                        <b-col>
                            {{ b.DeliveryPlaceStreet2 }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b>Hemtjänst:</b><br/>
                            {{ b.CustomerNo }}
                        </b-col>
                    </b-row>
                    
                    <b-row>
                        <b-col>
                            <b>Kommentar:</b><br />
                            {{ b.Comment }}
                        </b-col>

                    </b-row>
                    <!-- <b-row>
                        <b-col>
                            <b>Registrerad:</b> ?
                        </b-col>
                    </b-row> -->
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-row>
                        <b-col cols="8">
                            <b>Namn</b>
                        </b-col>
                        <b-col cols="3" class="text-right">
                            <b>Alt.</b>
                        </b-col>
                        <!-- <b-col cols="3">
                            <b>Kommentar</b>
                        </b-col> -->
                        <b-col cols="1" class="text-right">
                            <b>Antal</b>
                        </b-col>
                    </b-row>
                    <b-row v-for="(bc, j) in b.BookingCollis" :key="j" style="" class="delivery-note-row">
                        <b-col cols="8">
                            {{ bc.Name }}
                            {{ bc.Description }}
                        </b-col>
                        <b-col cols="3" class="text-right">
                            <h4><b>{{ bc.TypeOfColli }}</b></h4>
                        </b-col>
                        <!-- <b-col cols="3">
                            {{ bc.Comment }}
                            {{ bc.Ftx }}
                        </b-col> -->
                        <b-col cols="1" class="text-right" :class="getNoOfItemsClass(bc.NoOfItems)">
                            <h1>{{ bc.NoOfItems }}</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <hr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9"></b-col>
                        <b-col cols="2" class="text-right"><b>Totalt:</b></b-col>
                        <b-col cols="1" class="text-right"><h1>{{ b.NoOfItems }}</h1></b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();
import JsBarcode from 'jsbarcode';

export default {
    name: 'deliverynote',
    props: {
        booking: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            b: null,

        };
    },
    watch: {
        booking: function (newVal) {
            this.b = newVal;
            setTimeout(this.generateBarcode, 1);

        }
    },
    created() {
        // console.log("created deliverynote");
        this.b = this.booking;
    },
    mounted() {
        this.b = this.booking;
        setTimeout(this.generateBarcode, 1);

        // this.$nextTick(() => {
        //     this.generateBarcodes();
        // });
    },
    methods: {
        getBcRef(tspDocNo) {
            return `barcode-${tspDocNo}`;
        },
        generateBarcode() {
            if (this.b && this.b.TspDocNo) {
                var tspDocNo = this.b.TspDocNo;
                var elName = this.getBcRef(tspDocNo);
                var r = this.$refs[elName];
                if (r)
                    JsBarcode(r, tspDocNo, {
                        format: 'CODE128',
                        lineColor: '#000',
                        width: 2,
                        height: 100,
                        displayValue: true
                    });
            }
        },
        getNoOfItemsClass(noOfItems) {
            if (noOfItems === 1) return 'noofitems1';
            if (noOfItems === 2) return 'noofitems2';
            if (noOfItems === 3) return 'noofitems3';
            if (noOfItems === 4) return 'noofitems4';
            if (noOfItems === 5) return 'noofitems5';
            if (noOfItems >= 6) return 'noofitems6plus';
            return '';
        }
    },
};

</script>
<style scoped>
.delivery-note {
    font-size: x-large;
    /* page-break-after: always; */
    padding: 10px;
    /* border: 1px solid black; */
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    background-color: #fff;
}

.delivery-note-row {
    /* margin-bottom: 15px; */
    border-bottom: 0.5px solid #ccc;
}

.text-highlight {   
    font-size: 1em;
    font-weight: bold;
}

.noofitems1 {    
    font-weight: bold;    
}
.noofitems2 {
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(0, 255, 76);
}
.noofitems3 {
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(0, 162, 255);
}
.noofitems4 {
    font-size: 1.5em;
    font-weight: bold;
    color: rgba(255, 0, 140, 0.664);
}
.noofitems5 {
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(255, 55, 0);
}
.noofitems6plus {
    font-size: 1.5em;
    font-weight: bold;
    color: rgb(255, 55, 0);
    border: 2px solid rgb(255, 55, 0);
}

</style>